  import api from "@/api/api-v2-config";

export async function postUploadBankStatementAxios(payload) {    
    return await api.post("bankstatements/uploadbankstatement", payload);
}

export async function getUploadBankStatementAxios(BankID) {    
    return await api.get("bankstatements/bankstatement?BankId=" + BankID);
}

export async function getUploadBankStatementByIdAxios(statementID) {    
    return await api.get("bankstatements/" + statementID);
}

export async function updateUploadBankStatementAxios(payload) {
    return await api.put("bankstatements/updatebankstatementlinestatus", payload);
}